$(document).ready( function() {
  $('.sequence_new form .form-group input#sequence_creation_id').hide();
  $('.sequence_new form .form-group input#sequence_complete_id').hide();
  $('.sequence_new form .form-group input#sequence_lexigram_id').hide();
  $('.sequence_new form .form-group input#sequence_singular_id').hide();
  $('.sequence_new form .form-group .hiding').hide();
  $('.sequence_new form .form-group .noneed').hide();
  $('.sequence_new form .form-group input#sequence_user_id').hide();
});
